module.exports = "//public.zight.com/packs/media/images/icons-rainbow-circle-a7778366ed8e8436a5c6a2b306ccf5bc.png";